import { normalizeFormDefinition } from '@dec/shared';
import { type AxiosPromise, type AxiosRequestConfig } from 'axios';
import { type RefetchOptions } from 'axios-hooks';

import { useGetApplication } from '../../../hooks';
import { type FormDefinitionResponse } from '../models/definition.types';
const baseUrl = '/formdefinition';
export const useGetFormDefinition: (
  version: string,
  onLoad?: boolean,
  ignoreDefaultLang?: boolean
) => {
  loading: boolean;
  data: FormDefinitionResponse | undefined;
  error: any;
  response: any;

  execute: (
    config?: AxiosRequestConfig,
    options?: RefetchOptions
  ) => AxiosPromise<FormDefinitionResponse>;
} = (version: string, onLoad = true, ignoreDefaultLang = true) => {
  const [{ data, loading, error, response }, execute] = useGetApplication<FormDefinitionResponse>(
    {
      url: `${baseUrl}/${version}`,
      params: {},
      headers: ignoreDefaultLang ? { lang: true } : undefined
    },
    onLoad
  );

  return { loading, data: normalizeFormDefinition(data), error, response, execute };
};
